import { createRef, Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ArrowBtn } from './ArrowBtn';
import { Tooltip } from '../../Tooltip/Tooltip';
import ConfirmationModal from '../../../ConfirmationModal/ConfirmationModal';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import { EditableItem } from './types';

interface QtyEditableProps {
  item: EditableItem;
  labelsStore: {
    removeLabel: string;
    commonCancelLabel: string;
  };
  confirmStore: {
    contentText: string;
  }
};

interface QtyEditableState {
  isConfirmationModalVisible: boolean;
}

class _QtyEditable extends Component<QtyEditableProps, QtyEditableState> {
  constructor(props) {
    super(props);
    this.inputRef = createRef();
    this.state = {
      isConfirmationModalVisible: false,
    };
  }

  inputRef: any;

  qtyIncrease = () => this.props.item.changeQty(1);

  qtyDecrease = () => this.props.item.changeQty(-1);

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;

    this.props.item.changePublicQty(nextValue);
  };

  keyDownHandle = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyPressed = event.key.toLowerCase();

    if (keyPressed === 'enter' || keyPressed === 'escape') {
      this.inputRef.current.blur();
    }
  };

  handleAcceptModal = () => {
    this.setState({ isConfirmationModalVisible: false });
  };

  handleCancelModal = () => {
    this.setState({ isConfirmationModalVisible: false });
  };

  render() {
    const { quantity, countableTooltip, syncQty } = this.props.item;
    const { isConfirmationModalVisible } = this.state;
    const { labelsStore, confirmStore } = this.props;

    return (
      <>
        { isConfirmationModalVisible
          ? (
            <ConfirmationModal
              onAccept={this.handleAcceptModal}
              onCancel={this.handleCancelModal}
              onClose={this.handleCancelModal}
              description={confirmStore.contentText}
              confirmButtonText={labelsStore.removeLabel}
              cancelButtonText={labelsStore.commonCancelLabel}/>
            )
          :
            null
        }
        <div className={`card-qty ${countableTooltip ? 'tooltip-open' : ''}`}>
          {countableTooltip
          && (
            <Tooltip withIcon={false} modifier={countableTooltip.class || ''}>
              <div className="card-qty__attention-tooltip">
                <PesIcon class="attention-icon" size={pesIconSizes.MICRO}>
                  notification_critical
                </PesIcon>
                <span>{countableTooltip.msg}</span>
              </div>
            </Tooltip>
          )}

          <ArrowBtn changeQty={this.qtyDecrease} isPlus={false} />

          <input
            type="text"
            pattern="[0-9]*"
            className="card-qty__value"
            inputMode="numeric"
            value={quantity}
            onChange={this.handleChange}
            onKeyDown={this.keyDownHandle}
            onBlur={syncQty}
            ref={this.inputRef}
          />

          <ArrowBtn changeQty={this.qtyIncrease} isPlus />
        </div>
      </>
    );
  }
}

export const QtyEditable = inject('labelsStore', 'confirmStore')(observer(_QtyEditable));
